
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {fastCheck} from '@/api/sms/arrival-order';
import {Message} from "element-ui";

export default extend(table, {
	namespaced: true,
	state: {
		searchForm: {},
		multipleSelection:[],
		dataList:[]
	},
	actions: {
		async fastCheck({dispatch, commit, state}, payload) {
			const {multipleSelection} = state;
			if (multipleSelection.length <= 0) {
				return Message.error('至少选择一项进行批量验收');
			}
			for (let v of multipleSelection) {
				if(!v.print){
					return Message.warning('SKU:[' + v.skuValue + ']未打印条码，无法直接操作验收')
				}
			}
			await wait(dispatch, `sms.arrival-order.detail`, async function() {
				const response = await fastCheck({
					checkList: multipleSelection.map((v) => {
						return {
							deliveredOrderGoodsId: v.recId,
							deliveredOrderId: v.deliveredOrderId,
							curCheckNum: v.curCheckNum,
							storageLocation: v.storageLocation
						}
					}),
					moreCheck: false
				});
				if (response.data) {
					Message.success('验收成功')
					dispatch('handleResetSearch')
				}
			})
		},
		async handleResetSearch({ state, dispatch, commit }, payload) {
			commit('save', {
				searchForm: {},
				dataList: []
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/arrival-order/fast.js